var _pattern, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternFit15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1668.3 474.4",
    enableBackground: "new 0 0 1668.3 474.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    x: 2883.2,
    y: -214.8,
    width: 420.4,
    height: 420.4,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_6",
    viewBox: "0 -420.4 420.4 420.4",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -420.4,
    fill: "none",
    width: 420.4,
    height: 420.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M205.6-347.7c0,0,0,34.2,0,36.4c0,2.3-0.4,5.5-1.3,6.1c-0.9,0.6-4.1,1.5-10.9,1.5c-6.7,0-10-0.9-10.9-1.5 c-0.8-0.6-1.3-3.8-1.3-6.1c0-2.3,0-36.4,0-36.4s0.2-1.1,1.5-3.4c1.4-2.2,2.1-4.4-0.7-6c0,0-0.7-0.3-0.8-1.2c0-0.9-0.3-2.5,1-3.3 c0,0,5.5-1.1,11-1.1c5.6,0,11,1.1,11,1.1c1.3,0.8,1,2.4,1,3.3c0,0.9-0.8,1.2-0.8,1.2c-2.8,1.6-2.1,3.7-0.7,6 C205.4-348.9,205.6-347.7,205.6-347.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M205.3-362.3c0,0.5-0.8,0.6-0.8,0.6s-5.5-1.1-11-1.1c-5.6,0-11,1.1-11,1.1s-0.8-0.1-0.8-0.6 c0-0.5,0.6-6,0.6-6s1.1-2.1,7.5-2.8c0,0,0.6,0,0.5-3.6h-1.1c0,0,0.1-1.1,4.4-1.1c4.3,0,4.4,1.1,4.4,1.1h-1.1 c-0.1,3.5,0.5,3.6,0.5,3.6c6.4,0.7,7.5,2.8,7.5,2.8S205.3-362.8,205.3-362.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M219.4-189.8c0,0-34.2,0-36.4,0c-2.3,0-5.5-0.4-6.1-1.3c-0.6-0.9-1.5-4.1-1.5-10.9s0.9-10,1.5-10.9 c0.6-0.8,3.8-1.3,6.1-1.3c2.3,0,36.4,0,36.4,0s1.1,0.2,3.4,1.5c2.2,1.4,4.4,2.1,6-0.7c0,0,0.3-0.7,1.2-0.8c0.9,0,2.5-0.3,3.3,1 c0,0,1.1,5.5,1.1,11c0,5.6-1.1,11-1.1,11c-0.8,1.3-2.4,1-3.3,1c-0.9,0-1.2-0.8-1.2-0.8c-1.6-2.8-3.7-2.1-6-0.7 C220.6-190,219.4-189.8,219.4-189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M234-190.1c-0.5,0-0.6-0.8-0.6-0.8s1.1-5.5,1.1-11c0-5.6-1.1-11-1.1-11s0.1-0.8,0.6-0.8 c0.5,0,6,0.6,6,0.6s2.1,1.1,2.8,7.5c0,0,0,0.6,3.6,0.5v-1.1c0,0,1.1,0.1,1.1,4.4s-1.1,4.4-1.1,4.4v-1.1c-3.5-0.1-3.6,0.5-3.6,0.5 c-0.7,6.4-2.8,7.5-2.8,7.5S234.5-190.1,234-190.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M348.8-194.9c0,4.7-1.5,9.1-4.1,12.6c0,0-6.4,2.6-17.1,2.6c-10.8,0-17.1-2.6-17.1-2.6 c-2.6-3.5-4.1-7.9-4.1-12.6c0-4.9,1.6-9.4,4.4-12.9c0.8-1,1.7-2,2.7-2.9c3.8-3.4,8.8-5.5,14.2-5.5s10.5,2.1,14.2,5.5 c1,0.9,1.9,1.8,2.7,2.9C347.2-204.3,348.8-199.8,348.8-194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M346-205.4c-0.8-1-3.3-4.4-4.3-5.3c0,0,19.4-20.5-14.2-20.5c-33.7,0-14.2,20.5-14.2,20.5 c-1,0.9-3.3,3.4-4.1,4.4c0,0-24.4-30.4,18.3-30.4S346-205.4,346-205.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M122.2-181.5v55.7c0,1-0.7,1.8-1.6,1.8h-1.3c0.8,0,1.5-0.8,1.5-1.8v-55.7c0-1-0.7-1.8-1.5-1.8h1.3 C121.5-183.3,122.2-182.5,122.2-181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M128.1-174.2v41.2c0,0.9-0.7,1.6-1.6,1.6h-1c0.7,0,1.2-0.7,1.2-1.6v-41.2c0-0.8-0.5-1.5-1.2-1.5h1 C127.4-175.8,128.1-175.1,128.1-174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M132.6-166.5v25.7c0,0.7-0.6,1.2-1.2,1.2h-0.9c0.5,0,0.9-0.6,0.9-1.2v-25.7c0-0.7-0.4-1.2-0.9-1.2h0.9 C132-167.8,132.6-167.2,132.6-166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M179.9-51.1c1.8,3.1,2.8,6.7,2.8,10.6c0,4.7-1.5,9.1-4.2,12.6c0,0-6.4,2.6-17.1,2.6 c-10.8,0-17.1-2.6-17.1-2.6c-2.6-3.5-4.2-7.9-4.2-12.6c0-4.9,1.6-9.4,4.4-12.9c0.3-0.4,0.7-0.9,1.1-1.3c-1,1-2,2.2-2.5,2.8 c0,0-24.4-30.4,18.3-30.4C204.2-82.4,180-51.1,179.9-51.1C180-51.1,179.9-51.1,179.9-51.1z M175.7-56.4c0,0,19.4-20.5-14.2-20.5 c-33.7,0-14.2,20.5-14.2,20.5c3.8-3.4,8.8-5.5,14.2-5.5C166.9-61.9,171.9-59.8,175.7-56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M120.8-181.5v55.7c0,1-0.7,1.8-1.5,1.8h-4.5c-0.8,0-1.5-0.8-1.5-1.8v-23.8H0v-8.1h113.2v-23.8 c0-1,0.7-1.8,1.5-1.8h4.5C120.1-183.3,120.8-182.5,120.8-181.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M139.5-157.4v7.5c0,0.9-0.7,1.6-1.6,1.6h-5.4V-159h5.4C138.8-159,139.5-158.3,139.5-157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.2-181.5v55.7c0,1-0.7,1.8-1.6,1.8h-1.3c0.8,0,1.5-0.8,1.5-1.8v-55.7c0-1-0.7-1.8-1.5-1.8h1.3 C121.5-183.3,122.2-182.5,122.2-181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.1-174.2v41.2c0,0.9-0.7,1.6-1.6,1.6h-1c0.7,0,1.2-0.7,1.2-1.6v-41.2c0-0.8-0.5-1.5-1.2-1.5h1 C127.4-175.8,128.1-175.1,128.1-174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M126.8-174.2v41.2c0,0.9-0.5,1.6-1.2,1.6h-3.4v-44.2h3.4C126.2-175.8,126.8-175.1,126.8-174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M132.6-166.5v25.7c0,0.7-0.6,1.2-1.2,1.2h-0.9c0.5,0,0.9-0.6,0.9-1.2v-25.7c0-0.7-0.4-1.2-0.9-1.2h0.9 C132-167.8,132.6-167.2,132.6-166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M131.3-166.5v25.7c0,0.7-0.4,1.2-0.9,1.2h-2.4v-28.2h2.4C130.9-167.8,131.3-167.2,131.3-166.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M182.7-40.6c0,4.7-1.5,9.1-4.2,12.6c0,0-6.4,2.6-17.1,2.6c-10.8,0-17.1-2.6-17.1-2.6 c-2.6-3.5-4.2-7.9-4.2-12.6c0-4.9,1.6-9.4,4.4-12.9c0.3-0.4,0.7-0.9,1.1-1.3l0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.2,0.5-0.5,0.7-0.6c3.8-3.4,8.8-5.5,14.2-5.5c5.5,0,10.5,2.1,14.2,5.5 c0.1,0.1,0.1,0.1,0.2,0.2c0.9,0.8,1.7,1.7,2.5,2.7c0.6,0.8,1.1,1.5,1.6,2.4C181.7-48,182.7-44.4,182.7-40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180-51.1C180-51.1,179.9-51.1,180-51.1c-0.8-1.1-3-4-4.1-5.1c-0.1-0.1-0.1-0.1-0.2-0.2 c0,0,19.4-20.5-14.2-20.5c-33.7,0-14.2,20.5-14.2,20.5c-0.2,0.2-0.4,0.4-0.7,0.6c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3l-0.1,0.1c-1,1-2,2.2-2.5,2.8c0,0-24.4-30.4,18.3-30.4 C204.2-82.4,180-51.1,180-51.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.7-92.3L48.6-92l-0.8,2.4l-0.3,0.9L45.5-82l-0.9,3l-2.3-0.7l1-3.1l3.7-11.9l0-0.2l0.4,0.1l1.3,0.4 c-0.1,0.3-0.1,0.7-0.1,1c0,0.2,0,0.5,0,0.7C48.6-92.6,48.7-92.5,48.7-92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.2-92.1c0,1.2-0.3,2.3-0.8,3.3c-0.1,0.2-0.2,0.4-0.3,0.5c-1.3,2.3-3.8,3.9-6.7,3.9 c-2.8,0-5.3-1.6-6.7-3.8c-0.1-0.2-0.2-0.3-0.3-0.5c-0.5-1-0.8-2.1-0.8-3.3c0-0.2,0-0.5,0-0.7c0-0.2,0-0.4,0.1-0.6 c0.1-0.5,0.2-1,0.4-1.5c1.1-2.9,3.9-4.9,7.2-4.9s6,2,7.2,4.9v0c0.2,0.4,0.3,0.8,0.4,1.3c0.1,0.3,0.1,0.5,0.1,0.8 C62.2-92.5,62.2-92.3,62.2-92.1z M60.4-92.1c0-0.2,0-0.4,0-0.6c0-0.1,0-0.2,0-0.3c-0.5-2.8-2.9-4.9-5.8-4.9s-5.4,2.1-5.8,4.9 c0,0.1,0,0.2,0,0.3c0,0.2,0,0.5,0,0.7v0.1c0,0.4,0,0.7,0.1,1.1c0.5,2.7,2.9,4.8,5.8,4.8c2.9,0,5.3-2.1,5.8-4.9v0 C60.4-91.4,60.4-91.7,60.4-92.1L60.4-92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M62.2-93.5c0,0.2,0,0.5,0,0.7c-0.1,1.1-0.4,2.2-1,3.1c-1.3,2.3-3.8,3.9-6.7,3.9c-2.8,0-5.3-1.5-6.7-3.8 c-0.5-0.9-0.9-2-1-3.2c0-0.2,0-0.5,0-0.7c0-0.5,0-0.9,0.1-1.3c0.6-3.6,3.8-6.4,7.6-6.4c3.7,0,6.9,2.7,7.5,6.2 C62.1-94.5,62.2-94,62.2-93.5z M60.3-94.4c-0.5-2.8-2.9-4.9-5.8-4.9s-5.4,2.1-5.8,4.9c-0.1,0.3-0.1,0.7-0.1,1c0,0.2,0,0.5,0,0.7 c0,0.1,0,0.3,0.1,0.4c0.5,2.7,2.9,4.8,5.8,4.8c1.5,0,2.8-0.5,3.8-1.4c1-0.9,1.8-2.1,2-3.5c0-0.1,0-0.2,0-0.3c0-0.2,0-0.5,0-0.7 C60.4-93.8,60.4-94.1,60.3-94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M66.8-79.8l-2.3,0.7l-0.9-2.8l-2.1-6.9l-0.3-0.9l-0.8-2.5l-0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.2,0-0.5,0-0.7 c0-0.3,0-0.7-0.1-1l1.3-0.4v0L62-95l0,0l3.8,12.3L66.8-79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M82.1-40.6l-3.8,1.4c-1.5,0.5-3.2-0.2-3.8-1.8l-6.3-17.6l-3.9-10.9l-3-8.4c-0.5-1.5,0.3-3.2,1.8-3.8 l0.4-0.1l2.3-0.8L67-83c1.5-0.6,3.2,0.2,3.8,1.8l3,8.4c0,0,0,0,0,0l10.2,28.4C84.4-42.9,83.6-41.2,82.1-40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M82.4-40.7l-0.3,0.1l-3.8,1.4L78-39.2c-1.4,0.5-2.9-0.2-3.4-1.6L64.4-69.5c-0.5-1.4,0.2-2.9,1.6-3.4 l4.4-1.6c1.4-0.5,2.9,0.2,3.4,1.6c0,0,0,0,0,0l10.2,28.4l0.1,0.3C84.5-42.7,83.8-41.2,82.4-40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.2-77.9l-3,8.4c0,0,0,0,0,0l-3.9,10.9L35-41.1c-0.5,1.5-2.2,2.3-3.8,1.8l-3.9-1.4 c-1.4-0.6-2.2-2.1-1.7-3.6c0,0,0-0.1,0-0.1l10.2-28.4c0,0,0,0,0,0l3-8.4c0.5-1.5,2.2-2.3,3.8-1.8l0.6,0.2l2.3,0.8l0.9,0.3 C47.9-81.2,48.7-79.5,48.2-77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M45.2-69.6C45.2-69.5,45.2-69.5,45.2-69.6l-3.9,10.9l-6.4,17.9c-0.5,1.4-2,2.1-3.4,1.6l-0.3-0.1l-3.9-1.4 l-0.2-0.1c-1.4-0.5-2.1-2-1.6-3.4l0.1-0.2l10.2-28.5c0,0,0,0,0,0c0.5-1.3,2-2.1,3.4-1.6l4.4,1.6C44.9-72.4,45.6-70.9,45.2-69.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M343.5-339.7c1.8,3.1,2.8,6.7,2.8,10.5c0,4.7-1.5,9.1-4.1,12.6c0,0-6.4,2.6-17.1,2.6 c-10.8,0-17.1-2.6-17.1-2.6c-2.6-3.5-4.1-7.9-4.1-12.6c0-4.9,1.6-9.4,4.4-12.9c0.3-0.4,0.6-0.7,0.9-1.1c-0.9,0.9-1.8,2-2.3,2.6 c0,0-24.4-30.4,18.3-30.4C367.7-371,343.5-339.7,343.5-339.7z M339.2-345c0,0,19.4-20.5-14.2-20.5c-33.7,0-14.2,20.5-14.2,20.5 c3.8-3.4,8.8-5.5,14.2-5.5C330.4-350.4,335.4-348.4,339.2-345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M409.7-284.4v7.5c0,0.9-0.7,1.6-1.6,1.6h-5.4v7.6c0,0.7-0.6,1.2-1.2,1.2h-3.2v6.5c0,0.9-0.7,1.6-1.5,1.6 h-4.3v5.7c0,1-0.7,1.8-1.6,1.8h-5.8c-0.8,0-1.5-0.8-1.5-1.8v-23.8H263.8v23.8c0,1-0.7,1.8-1.5,1.8h-5.8c-0.9,0-1.6-0.8-1.6-1.8 v-5.7h-4.3c-0.9,0-1.6-0.7-1.6-1.6v-6.5h-3.2c-0.7,0-1.2-0.6-1.2-1.2v-7.6h-5.4c-0.9,0-1.6-0.7-1.6-1.6v-7.5 c0-0.9,0.7-1.6,1.6-1.6h5.4v-7.6c0-0.7,0.6-1.2,1.2-1.2h3.2v-6.5c0-0.9,0.7-1.6,1.6-1.6h4.3v-5.7c0-1,0.7-1.8,1.6-1.8h5.8 c0.8,0,1.5,0.8,1.5,1.8v23.8h119.6v-23.8c0-1,0.7-1.8,1.5-1.8h5.8c0.9,0,1.6,0.8,1.6,1.8v5.7h4.3c0.8,0,1.5,0.7,1.5,1.6v6.5h3.2 c0.7,0,1.2,0.6,1.2,1.2v7.6h5.4C409-285.9,409.7-285.2,409.7-284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M410.3-376.3c0.5,0.4,1,0.8,1.5,1.1C411.3-375.5,410.8-375.9,410.3-376.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M412.5-374.6c0.3,0.3,0.7,0.5,1,0.7C413.2-374.1,412.8-374.4,412.5-374.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256.5-402.1h-1.1c-0.7,0-1.2-0.6-1.2-1.4v-16.9h1.1v16.9C255.4-402.8,255.9-402.1,256.5-402.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M261.2-420.4v16.9c0,0.8-0.5,1.4-1.2,1.4h-3.4c-0.6,0-1.2-0.6-1.2-1.4v-16.9H261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M251.7-407.9H251c-0.7,0-1.2-0.5-1.2-1.2v-11.4h1v11.4C250.8-408.4,251.2-407.9,251.7-407.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M254.3-420.4v12.6h-2.6c-0.5,0-0.9-0.5-0.9-1.2v-11.4H254.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M248-414h-0.7c-0.5,0-1-0.4-1-0.9v-5.5h0.9v5.5C247.3-414.5,247.6-414,248-414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M249.8-420.4v6.4H248c-0.4,0-0.7-0.4-0.7-0.9v-5.5H249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M307.5-420.4v16.9c0,0.8-0.5,1.4-1.2,1.4h-1c0.6,0,1.2-0.6,1.2-1.4v-16.9H307.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M306.5-420.4v16.9c0,0.8-0.5,1.4-1.2,1.4h-3.4c-0.6,0-1.2-0.6-1.2-1.4v-16.9H306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M312-420.4v11.4c0,0.6-0.5,1.2-1.2,1.2h-0.7c0.5,0,0.9-0.5,0.9-1.2v-11.4H312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M311-420.4v11.4c0,0.6-0.4,1.2-0.9,1.2h-2.6v-12.6H311z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M315.5-420.4v5.5c0,0.5-0.4,0.9-1,0.9h-0.7c0.4,0,0.7-0.4,0.7-0.9v-5.5H315.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M314.5-420.4v5.5c0,0.5-0.3,0.9-0.7,0.9H312v-6.4H314.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.8,
    y: -284.7,
    fill: "#F37421",
    width: 124.3,
    height: 8.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M409.7-284.4v7.5c0,0.9-0.7,1.6-1.6,1.6h-5.4v-10.6h5.4C409-285.9,409.7-285.2,409.7-284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M392.3-308.5v55.7c0,1-0.7,1.8-1.6,1.8H386c-0.9,0-1.6-0.8-1.6-1.8v-55.7c0-1,0.7-1.8,1.6-1.8h4.7 C391.6-310.3,392.3-309.5,392.3-308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M390.9-308.5v55.7c0,1-0.7,1.8-1.5,1.8h-4.5c-0.8,0-1.5-0.8-1.5-1.8v-55.7c0-1,0.7-1.8,1.5-1.8h4.5 C390.2-310.3,390.9-309.5,390.9-308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M398.2-301.2v41.1c0,0.9-0.7,1.6-1.5,1.6h-4.3v-44.3h4.3C397.5-302.8,398.2-302.1,398.2-301.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M396.9-301.2v41.1c0,0.9-0.5,1.6-1.2,1.6h-3.4v-44.3h3.4C396.4-302.8,396.9-302.1,396.9-301.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M402.7-293.5v25.7c0,0.7-0.6,1.2-1.2,1.2h-3.2v-28.2h3.2C402.1-294.7,402.7-294.2,402.7-293.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M401.5-293.5v25.7c0,0.7-0.4,1.2-0.9,1.2h-2.4v-28.2h2.4C401.1-294.7,401.5-294.2,401.5-293.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M244.5-285.9v10.6h-5.4c-0.9,0-1.6-0.7-1.6-1.6v-7.5c0-0.9,0.7-1.6,1.6-1.6H244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M262.8-308.5v55.7c0,1-0.7,1.8-1.6,1.8h-4.7c-0.9,0-1.6-0.8-1.6-1.8v-55.7c0-1,0.7-1.8,1.6-1.8h4.7 C262-310.3,262.8-309.5,262.8-308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M263.8-308.5v55.7c0,1-0.7,1.8-1.5,1.8h-4.5c-0.8,0-1.5-0.8-1.5-1.8v-55.7c0-1,0.7-1.8,1.5-1.8h4.5 C263.1-310.3,263.8-309.5,263.8-308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M254.9-302.8v44.3h-4.3c-0.9,0-1.6-0.7-1.6-1.6v-41.1c0-0.9,0.7-1.6,1.6-1.6H254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M254.9-302.8v44.3h-3.4c-0.7,0-1.2-0.7-1.2-1.6v-41.1c0-0.9,0.6-1.6,1.2-1.6H254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M249-294.7v28.2h-3.2c-0.7,0-1.2-0.6-1.2-1.2v-25.7c0-0.7,0.6-1.2,1.2-1.2H249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M249-294.7v28.2h-2.4c-0.5,0-0.9-0.6-0.9-1.2v-25.7c0-0.7,0.4-1.2,0.9-1.2H249z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M346.2-329.1c0,4.7-1.5,9.1-4.1,12.6c0,0-6.4,2.6-17.1,2.6c-10.8,0-17.1-2.6-17.1-2.6 c-2.6-3.5-4.1-7.9-4.1-12.6c0-4.9,1.6-9.4,4.4-12.9c0.3-0.4,0.6-0.7,0.9-1.1c0,0,0-0.1,0.1-0.1c0.2-0.3,0.5-0.6,0.8-0.8l0.3-0.3 c0.3-0.2,0.5-0.5,0.7-0.6c3.8-3.4,8.8-5.5,14.2-5.5c5.5,0,10.5,2.1,14.2,5.5c0.1,0.1,0.1,0.1,0.2,0.2c0.9,0.8,1.7,1.7,2.5,2.7 c0.6,0.8,1.1,1.6,1.6,2.4C345.2-336.6,346.2-333,346.2-329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M343.5-339.7c-0.8-1-3-4-4.1-5.1c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,19.4-20.5-14.2-20.5 c-33.7,0-14.2,20.5-14.2,20.5c-0.2,0.2-0.4,0.4-0.7,0.6l-0.3,0.3c-0.3,0.3-0.5,0.5-0.8,0.8c0,0,0,0.1-0.1,0.1 c-0.9,0.9-1.8,2-2.3,2.6c0,0-24.4-30.4,18.3-30.4C367.7-371,343.5-339.7,343.5-339.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M415.5-372.4c-0.1,0-0.3-0.2-0.6-0.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.5-0.4 s-0.4-0.3-0.6-0.4c0,0,0,0-0.1,0c-0.3-0.2-0.6-0.5-1-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.5-0.3-0.9-0.7-1.5-1.1c0,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.6-1.1-0.9c0-0.1-0.1-0.1-0.2-0.1c-0.5-0.4-1.1-0.9-1.6-1.3 c-2-1.6-4.1-3.4-6.1-5.3c-0.2-0.2-0.3-0.3-0.5-0.5c-0.4-0.4-0.7-0.7-1.1-1.1c-0.4-0.4-0.8-0.8-1.2-1.2c-1.8-1.9-3.3-3.7-4.4-5.4 c-0.2-0.3-0.3-0.5-0.5-0.8c-0.2-0.4-0.4-0.9-0.6-1.3c3.1-7.5,9.3-13.5,17.1-16.2c0,0-0.3,3.7-0.2,9c0,0.5,0,1.1,0,1.7 c0,0.6,0,1.2,0.1,1.8c0,0.6,0.1,1.2,0.1,1.9c0.1,1.6,0.3,3.3,0.5,5c0.1,0.7,0.2,1.4,0.3,2.1c0,0.4,0.1,0.7,0.2,1.1 c0.2,1.4,0.5,2.8,0.8,4.2c0.1,0.4,0.1,0.7,0.2,1.1c0.3,1.3,0.7,2.6,1,3.9c0.1,0.2,0.1,0.4,0.2,0.7c0.1,0.2,0.2,0.5,0.2,0.7 C414.1-375.7,414.8-374,415.5-372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M410.3-376.3c0.5,0.4,1,0.8,1.5,1.1C411.3-375.5,410.8-375.9,410.3-376.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M412.5-374.6c0.3,0.3,0.7,0.5,1,0.7C413.2-374.1,412.8-374.4,412.5-374.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M420.4-412.1v57.3c-0.3,0-0.6,0-0.9,0c-15.8,0-28.7-12.8-28.7-28.7c0-3.9,0.8-7.5,2.1-10.9 c0.2,0.4,0.4,0.8,0.6,1.3c0.1,0.3,0.3,0.5,0.5,0.8c1.1,1.7,2.6,3.6,4.4,5.4c0.4,0.4,0.8,0.8,1.2,1.2c0.4,0.3,0.7,0.7,1.1,1.1 c0.2,0.2,0.3,0.3,0.5,0.5c2,1.9,4.1,3.7,6.1,5.3c0.6,0.5,1.1,0.9,1.6,1.3c0.1,0,0.1,0.1,0.2,0.1c0.4,0.3,0.8,0.6,1.1,0.9 c0,0,0.1,0.1,0.2,0.1c0.5,0.4,1,0.8,1.5,1.1c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.3,0.3,0.7,0.5,1,0.7 c0,0,0,0,0.1,0c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.3,0.6,0.4,0.6,0.4 c-0.8-1.6-1.4-3.3-2-5c-0.1-0.2-0.2-0.5-0.2-0.7c-0.1-0.2-0.1-0.4-0.2-0.7c-0.4-1.3-0.7-2.6-1-3.9c-0.1-0.4-0.2-0.7-0.2-1.1 c-0.3-1.4-0.6-2.8-0.8-4.2c-0.1-0.3-0.1-0.7-0.2-1.1c-0.1-0.7-0.2-1.4-0.3-2.1c-0.2-1.7-0.4-3.4-0.5-5c0-0.6-0.1-1.3-0.1-1.9 c0-0.6-0.1-1.2-0.1-1.8c0-0.6,0-1.2,0-1.7c-0.1-5.4,0.2-9,0.2-9c3-1,6.1-1.6,9.5-1.6C419.8-412.1,420.1-412.1,420.4-412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M411.8-375.2c-0.5-0.3-1-0.7-1.5-1.1C410.8-375.9,411.3-375.5,411.8-375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M413.5-373.9c-0.3-0.2-0.6-0.5-1-0.7C412.8-374.4,413.2-374.1,413.5-373.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M160.5-399.3v5.8c0,0.8-0.8,1.5-1.8,1.5H135v119.6h23.8c1,0,1.8,0.7,1.8,1.5v5.8c0,0.9-0.8,1.6-1.8,1.6 H153v4.4c0,0.9-0.7,1.5-1.6,1.5H145v3.2c0,0.7-0.6,1.2-1.2,1.2h-7.6v5.4c0,0.9-0.7,1.6-1.6,1.6h-7.5c-0.9,0-1.6-0.7-1.6-1.6v-5.4 H118c-0.7,0-1.2-0.6-1.2-1.2v-3.2h-6.5c-0.9,0-1.5-0.7-1.5-1.5v-4.4h-5.7c-1,0-1.8-0.7-1.8-1.6v-5.8c0-0.8,0.8-1.5,1.8-1.5h23.8 V-392h-23.8c-1,0-1.8-0.7-1.8-1.5v-5.8c0-0.9,0.8-1.6,1.8-1.6h5.7v-4.4c0-0.9,0.7-1.6,1.5-1.6h6.5v-3.2c0-0.7,0.5-1.2,1.2-1.2h7.6 v-5.4c0-0.9,0.7-1.6,1.6-1.6h7.5c0.9,0,1.6,0.7,1.6,1.6v5.4h7.6c0.7,0,1.2,0.6,1.2,1.2v3.2h6.5c0.9,0,1.6,0.7,1.6,1.6v4.4h5.7 C159.7-400.9,160.5-400.2,160.5-399.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.8,
    y: -393,
    fill: "#F37421",
    width: 8.1,
    height: 124.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M136.2-253.1v5.4c0,0.9-0.7,1.6-1.6,1.6h-7.5c-0.9,0-1.6-0.7-1.6-1.6v-5.4H136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.5-269.7v4.7c0,0.9-0.8,1.6-1.8,1.6h-55.7c-1,0-1.8-0.7-1.8-1.6v-4.7c0-0.9,0.8-1.6,1.8-1.6h55.7 C159.7-271.3,160.5-270.6,160.5-269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M160.5-270.9v4.5c0,0.8-0.8,1.5-1.8,1.5h-55.7c-1,0-1.8-0.7-1.8-1.5v-4.5c0-0.8,0.8-1.5,1.8-1.5h55.7 C159.7-272.4,160.5-271.7,160.5-270.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153-263.5v4.4c0,0.9-0.7,1.5-1.6,1.5h-41.1c-0.9,0-1.5-0.7-1.5-1.5v-4.4H153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M153-263.5v3.4c0,0.7-0.7,1.2-1.6,1.2h-41.1c-0.9,0-1.5-0.5-1.5-1.2v-3.4H153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145-257.6v3.2c0,0.7-0.6,1.2-1.2,1.2H118c-0.7,0-1.2-0.6-1.2-1.2v-3.2H145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M145-257.5v2.3c0,0.5-0.6,0.9-1.2,0.9H118c-0.7,0-1.2-0.4-1.2-0.9v-2.3H145z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M136.2-416.7v5.4h-10.6v-5.4c0-0.9,0.7-1.6,1.6-1.6h7.5C135.5-418.3,136.2-417.6,136.2-416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.5-399.3v4.7c0,0.9-0.8,1.6-1.8,1.6h-55.7c-1,0-1.8-0.7-1.8-1.6v-4.7c0-0.9,0.8-1.6,1.8-1.6h55.7 C159.7-400.9,160.5-400.2,160.5-399.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M160.5-398v4.5c0,0.8-0.8,1.5-1.8,1.5h-55.7c-1,0-1.8-0.7-1.8-1.5v-4.5c0-0.8,0.8-1.5,1.8-1.5h55.7 C159.7-399.5,160.5-398.8,160.5-398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153-405.2v4.4h-44.3v-4.4c0-0.9,0.7-1.6,1.5-1.6h41.1C152.3-406.8,153-406.1,153-405.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M153-404.3v3.4h-44.3v-3.4c0-0.7,0.7-1.2,1.5-1.2h41.1C152.3-405.5,153-405,153-404.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145-410v3.2h-28.2v-3.2c0-0.7,0.5-1.2,1.2-1.2h25.7C144.4-411.3,145-410.7,145-410z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M145-409.2v2.4h-28.2v-2.4c0-0.5,0.5-0.9,1.2-0.9h25.7C144.4-410.1,145-409.7,145-409.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M52.1-266.9c0,0,0,34.2,0,36.4c0,2.3-0.4,5.5-1.3,6.1c-0.9,0.6-4.1,1.5-10.9,1.5s-10-0.9-10.9-1.5 c-0.8-0.6-1.3-3.8-1.3-6.1c0-2.3,0-36.4,0-36.4s0.2-1.1,1.6-3.4c1.4-2.2,2.1-4.4-0.7-6c0,0-0.7-0.3-0.8-1.2c0-0.9-0.3-2.5,1-3.3 c0,0,5.5-1.1,11-1.1c5.6,0,11,1.1,11,1.1c1.3,0.8,1,2.4,1,3.3c0,1-0.8,1.2-0.8,1.2c-2.8,1.6-2.1,3.7-0.7,6 C51.9-268,52.1-266.9,52.1-266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.8-281.4c0,0.5-0.8,0.6-0.8,0.6s-5.5-1.1-11-1.1c-5.6,0-11,1.1-11,1.1s-0.8-0.1-0.8-0.6 c0-0.5,0.6-6,0.6-6s1.1-2.1,7.5-2.8c0,0,0.6,0,0.5-3.6h-1.1c0,0,0.1-1.1,4.4-1.1s4.4,1.1,4.4,1.1h-1.2c-0.1,3.5,0.5,3.6,0.5,3.6 c6.4,0.7,7.5,2.8,7.5,2.8S51.8-282,51.8-281.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M7.3-399.3c0,0,1.9,29.5,8.7,39.1c-0.5,0.4-1,0.7-1.5,1c-4.2,2.7-9.2,4.3-14.5,4.5v-57.3 c15.4,0.5,27.8,13.1,27.8,28.6c0,1.5-0.1,2.9-0.3,4.3C20.3-384.4,12.5-391.4,7.3-399.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.5-379.1c-0.3,2.2-0.9,4.4-1.8,6.5c-2,5-5.4,9.3-9.7,12.4c-6.9-9.6-8.7-39.1-8.7-39.1 C12.5-391.4,20.3-384.4,27.5-379.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M305.4-129.1c0,1.5-0.1,2.9-0.3,4.3c-0.3,2.2-0.9,4.4-1.8,6.5c-2,5-5.4,9.3-9.7,12.4 c-0.5,0.4-1,0.7-1.5,1c-4.5,2.9-9.8,4.5-15.4,4.5c-15.8,0-28.7-12.8-28.7-28.7c0-3.9,0.8-7.5,2.1-10.9 c3.1-7.5,9.3-13.5,17.1-16.2c3-1,6.1-1.6,9.5-1.6C292.6-157.8,305.4-145,305.4-129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M387.2-68.1c0,0,0,34.2,0,36.4c0,2.3-0.5,5.5-1.3,6.1c-0.8,0.6-4.1,1.5-10.9,1.5s-10-0.9-10.9-1.5 c-0.9-0.6-1.3-3.8-1.3-6.1c0-2.3,0-36.4,0-36.4s0.2-1.2,1.5-3.4c1.4-2.2,2.1-4.4-0.7-6c0,0-0.7-0.3-0.8-1.2c0-0.9-0.3-2.5,1-3.3 c0,0-0.8-0.1-0.8-0.6c0-0.5,0.6-5.9,0.6-5.9s1.1-2.1,7.5-2.8c0,0,0.6,0,0.5-3.6h-1.1c0,0,0.1-1.1,4.3-1.1c4.3,0,4.4,1.1,4.4,1.1 h-1.1c-0.1,3.5,0.5,3.6,0.5,3.6c6.4,0.7,7.5,2.8,7.5,2.8s0.6,5.4,0.6,5.9c0,0.5-0.8,0.6-0.8,0.6c1.3,0.8,1,2.4,1,3.3 s-0.8,1.2-0.8,1.2c-2.8,1.6-2.1,3.7-0.7,6C387-69.2,387.2-68.1,387.2-68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M396.9-139.6H396c-0.7,0-1.2-0.6-1.2-1.2v-25.7c0-0.7,0.6-1.2,1.2-1.2h0.9c-0.5,0-0.9,0.6-0.9,1.2v25.7 C396-140.1,396.4-139.6,396.9-139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M401.8-131.5h-1c-0.9,0-1.6-0.7-1.6-1.6v-41.2c0-0.8,0.7-1.5,1.6-1.5h1c-0.7,0-1.2,0.7-1.2,1.5v41.2 C400.6-132.2,401.1-131.5,401.8-131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M408.1-124h-1.3c-0.9,0-1.6-0.8-1.6-1.8v-55.7c0-1,0.7-1.8,1.6-1.8h1.3c-0.8,0-1.5,0.8-1.5,1.8v55.7 C406.6-124.8,407.3-124,408.1-124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M314.5-14.2V0H312v-15.2h1.8C314.2-15.2,314.5-14.8,314.5-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M246.4-8.4v8.1h-4.1c-0.7,0-1.2-0.5-1.2-1.2v-5.7c0-0.7,0.5-1.2,1.2-1.2H246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256.5-27.1c-0.6,0-1.2,0.6-1.2,1.4V0h-1.1v-25.7c0-0.8,0.5-1.4,1.2-1.4H256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M251.7-21.3c-0.5,0-0.9,0.5-0.9,1.2V0h-1v-20.1c0-0.7,0.5-1.2,1.2-1.2H251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M254.3-21.3V0h-3.5v-20.1c0-0.7,0.4-1.2,0.9-1.2H254.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M248-15.2c-0.4,0-0.7,0.4-0.7,1V0h-0.9v-14.2c0-0.5,0.4-1,1-1H248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M249.8-15.2V0h-2.5v-14.2c0-0.5,0.3-1,0.7-1H249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M320.8-7.2v5.7c0,0.7-0.5,1.2-1.2,1.2h-4.1v-8.1h4.1C320.3-8.4,320.8-7.9,320.8-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M307.5-25.7V0h-1.1v-25.7c0-0.8-0.5-1.4-1.2-1.4h1C307-27.1,307.5-26.5,307.5-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M306.5-25.7V0h-5.8v-0.3h-39.5V0h-5.8v-25.7c0-0.8,0.5-1.4,1.2-1.4h3.4c0.6,0,1.2,0.6,1.2,1.4v17.3h39.5 v-17.3c0-0.8,0.5-1.4,1.2-1.4h3.4C305.9-27.1,306.5-26.5,306.5-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M312-20.1V0h-1v-20.1c0-0.7-0.4-1.2-0.9-1.2h0.7C311.5-21.3,312-20.8,312-20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M311-20.1V0h-3.5v-21.3h2.6C310.6-21.3,311-20.8,311-20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M315.5-14.2V0h-0.9v-14.2c0-0.5-0.3-1-0.7-1h0.7C315-15.2,315.5-14.8,315.5-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M314.5-14.2V0H312v-15.2h1.8C314.2-15.2,314.5-14.8,314.5-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M314.5-14.2V0H312v-15.2h1.8C314.2-15.2,314.5-14.8,314.5-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M420.4-157.7v8.1h-6.3v23.8c0,1-0.7,1.8-1.5,1.8h-4.5c-0.8,0-1.5-0.8-1.5-1.8v-55.7c0-1,0.7-1.8,1.5-1.8 h4.5c0.8,0,1.5,0.8,1.5,1.8v23.8H420.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M394.8-159v10.6h-5.4c-0.9,0-1.6-0.7-1.6-1.6v-7.5c0-0.9,0.7-1.6,1.6-1.6H394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M408.1-124h-1.3c-0.9,0-1.6-0.8-1.6-1.8v-55.7c0-1,0.7-1.8,1.6-1.8h1.3c-0.8,0-1.5,0.8-1.5,1.8v55.7 C406.6-124.8,407.3-124,408.1-124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M401.8-131.5h-1c-0.9,0-1.6-0.7-1.6-1.6v-41.2c0-0.8,0.7-1.5,1.6-1.5h1c-0.7,0-1.2,0.7-1.2,1.5v41.2 C400.6-132.2,401.1-131.5,401.8-131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M405.2-175.8v44.2h-3.4c-0.7,0-1.2-0.7-1.2-1.6v-41.2c0-0.8,0.5-1.5,1.2-1.5H405.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M396.9-139.6H396c-0.7,0-1.2-0.6-1.2-1.2v-25.7c0-0.7,0.6-1.2,1.2-1.2h0.9c-0.5,0-0.9,0.6-0.9,1.2v25.7 C396-140.1,396.4-139.6,396.9-139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M399.3-167.8v28.2h-2.4c-0.5,0-0.9-0.6-0.9-1.2v-25.7c0-0.7,0.4-1.2,0.9-1.2H399.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M387.2-68.1c0,0,0,34.2,0,36.4c0,2.3-0.5,5.5-1.3,6.1c-0.8,0.6-4.1,1.5-10.9,1.5s-10-0.9-10.9-1.5 c-0.9-0.6-1.3-3.8-1.3-6.1c0-2.3,0-36.4,0-36.4s0.2-1.2,1.5-3.4c1.4-2.2,2.1-4.4-0.7-6c0,0-0.7-0.3-0.8-1.2c0-0.9-0.3-2.5,1-3.3 c0,0,5.5-1.1,11-1.1c5.6,0,11,1.1,11,1.1c1.3,0.8,1,2.4,1,3.3s-0.8,1.2-0.8,1.2c-2.8,1.6-2.1,3.7-0.7,6 C387-69.2,387.2-68.1,387.2-68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M386.9-82.6c0,0.5-0.8,0.6-0.8,0.6s-5.5-1.1-11-1.1c-5.6,0-11,1.1-11,1.1s-0.8-0.1-0.8-0.6 c0-0.5,0.6-5.9,0.6-5.9s1.1-2.1,7.5-2.8c0,0,0.6,0,0.5-3.6h-1.1c0,0,0.1-1.1,4.3-1.1c4.3,0,4.4,1.1,4.4,1.1h-1.1 c-0.1,3.5,0.5,3.6,0.5,3.6c6.4,0.7,7.5,2.8,7.5,2.8S386.8-83.1,386.9-82.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M272.7-118.1c-0.6-0.4-19.1-13.5-22.5-21.9c3.1-7.5,9.3-13.5,17.1-16.2 C267.3-156.2,265.4-133.7,272.7-118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M305.4-129.1c0,1.5-0.1,2.9-0.3,4.3c-0.3,2.2-0.9,4.4-1.8,6.5c-2,5-5.4,9.3-9.7,12.4 c-0.5,0.4-1,0.7-1.5,1c-4.5,2.9-9.8,4.5-15.4,4.5c-15.8,0-28.7-12.8-28.7-28.7c0-3.9,0.8-7.5,2.1-10.9 c3.4,8.4,21.9,21.5,22.5,21.9c-7.3-15.6-5.4-38.1-5.4-38.1c3-1,6.1-1.6,9.5-1.6C292.6-157.8,305.4-145,305.4-129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M305.1-124.9c-0.3,2.2-0.9,4.4-1.8,6.5c-2,5-5.4,9.3-9.7,12.4c-6.9-9.6-8.7-39.1-8.7-39.1 C290.2-137.1,297.9-130.2,305.1-124.9z"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#New_Pattern_6)",
    width: 1668.3,
    height: 474.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternFit15);
export default __webpack_public_path__ + "static/media/patternFit-15.93aa2e55820d1db5c3a35a2bd9f333b3.svg";
export { ForwardRef as ReactComponent };